export const MAX_IMAGE_HEIGHT = 250;
export const MAX_IMAGE_WIDTH = 400;
export const learnMoreUrl =
	'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-queues/';
